<template>
    <form method="post" enctype="multipart/form-data">
        <div class="radio-activity">
            <label>Vous utilisez l'hypnose et les thérapies brèves dans une activité: *</label>
            <div class="radios">
                <input
                    v-model="state.activity.isEmployee"
                    :value="false"
                    type="radio"
                    id="self"
                    name="activity"
                />
                <label style="margin: 0; padding: 0 0.25rem" for="self">à votre compte</label>
                <input
                    v-model="state.activity.isEmployee"
                    :value="true"
                    type="radio"
                    id="employee"
                    name="activity"
                />
                <label style="margin: 0; padding: 0 0.25rem" for="employee">en tant que salarié</label>
            </div>

            <ErrorMessage
                v-if="v && isError(v.activity.isEmployee)"
                message="Ce champ est nécessaire"
            />
        </div>

        <slot v-if="!state.activity.isEmployee">
            <h4>Les questions ci-dessous concernent les personnes exerçant en tant qu'indépendant (hors salarié).</h4>
            <label for="input-legal-status">Quel est le statut juridique de votre entreprise ? *</label>
            <select
                :class="v && isError(v.activity.legalStatus) ? 'error' : null"
                v-model="state.activity.legalStatus"
                id="input-legal-status"
            >
                <option v-for="status in legalStatus" :key="status" :value="status">{{ status }}</option>
            </select>
            <ErrorMessage
                v-if="v && isError(v.activity.legalStatus)"
                message="Ce champ est nécessaire"
            />

            <label for="input-siret">Le numéro de SIRET de votre entreprise *</label>
            <input
                :class="v && isError(v.activity.siret) ? 'error' : null"
                v-model="state.activity.siret"
                type="text"
                id="input-siret"
                maxlength="14"
            />
            <ErrorMessage
                v-if="v && isError(v.activity.siret) && state.activity.siret.length === 0"
                message="Ce champ est nécessaire"
            />
            <ErrorMessage
                v-if="v && isError(v.activity.siret) && state.activity.siret.length > 0"
                message="Veuillez saisir un numéro de siret à 14 chiffres"
            />
            <span>(14 chiffres)</span>

            <label for="input-ape">Le Code de l'Activité Principale Exercée (code APE) *</label>
            <input
                :class="v && isError(v.activity.apeCode) ? 'error' : null"
                v-model="state.activity.apeCode"
                type="text"
                id="input-ape"
                maxlength="5"
            />
            <ErrorMessage
                v-if="v && isError(v.activity.apeCode) && state.activity.apeCode.length === 0"
                message="Ce champ est nécessaire"
            />
            <ErrorMessage
                v-if="v && isError(v.activity.apeCode) && state.activity.apeCode.length > 0"
                message="Veuillez saisir un code APE correct (4 chiffres + 1 lettre)"
            />
            <span style="padding-top: 0.3rem">
                Ce code est attribué par l'URSSAF en fonction du répertoire INSEE. Vous pouvez trouver cette information sur votre certificat
                d'inscription au répertoire des entreprises. (4 chiffres + 1 lettre)
            </span>

            <label for="input-business-date">Date de création de votre entreprise *</label>
            <InputVCalendar
                :error="v && isError(v.activity.businessCreation)"
                v-model="state.activity.businessCreation"
            ></InputVCalendar>
            <ErrorMessage
                v-if="v && isError(v.activity.businessCreation)"
                message="Ce champ est nécessaire"
            />
        </slot>
        <InputFile
            :error="v && isError(v.activity.files)"
            labelText="Pour tous, veuillez nous transmettre les documents suivants *"
            keyStore="activity"
        ></InputFile>
        <ErrorMessage
            v-if="v && isError(v.activity.files)"
            message="Veuillez téléversez au minimum un fichier"
        />
        <strong>
            - si vous exercez en tant qu'indépendant, veuillez joindre ci-dessus une copie de votre certificat d'inscription
            au répertoire des Entreprises et des Etablissements délivré par l'INSEE
        </strong>
        <strong>
            - si vous utilisez en tant que salarié, veuillez joindre ci-dessus les éléments de votre contrat de travail où sont mentionnés
            le nom de votre employeur et le cadre de l'utilisation de l'hypnose
        </strong>
    </form>
</template>

<script>
import { ref } from "vue";
import { state } from "../../store";
import { isError } from '../../validation';
import ErrorMessage from '../errors/ErrorMessage.vue';
import InputVCalendar from "../Inputs/InputVCalendar.vue";
import InputFile from "../Inputs/InputFile.vue";

export default {
    name: "SecondStep",
    components: { ErrorMessage, InputVCalendar, InputFile },
    props: {
        v: {
            type: Object
        }
    },
    setup() {
        const legalStatus = ref(["Auto-entreprise", "Entreprise individuelle hors micro", "EURL", "SARL", "SASU", "Autre"]);

        const pickFile = (pickedFile) => {
            state.activity.files = pickedFile.target.files;
        }

        return { state, legalStatus, pickFile, isError };
    }
}
</script>

<style lang="scss" scoped>
h4,
span,
strong {
    text-align: left;
    margin-bottom: 1em;
}

span {
    color: gray;
    font-size: 12px;
}

.radio-activity {
    .radios {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
